import React from 'react';
import SmartiLabIcon from './SmartiLabIcon';

export default function LabEmptyState({ title, description }) {
  return (
    <div className="lab-empty-state">
      <span className="lab-page-icon"><SmartiLabIcon compact /></span>
      <strong>{title}</strong>
      {typeof description === 'string' ? <p>{description}</p> : description}
    </div>
  );
}
